import { html } from 'lit';

export default (o) => html`<p>${o.text}</p>`;
